import { Link } from "react-router-dom";

const relatedArticles = [
  {
    id: 1,
    title: "Calm Living Room Ideas in Soft Beige",
    category: "Living Rooms",
    path: "/living-room/soft-beige",
    image: "https://public.readdy.ai/ai/img_res/0375394cd30835bff3fe087c0eeaedc1.jpg",
  },
  {
    id: 2,
    title: "Quiet Window Nook Styling",
    category: "Cozy Corners",
    path: "/cozy-corners",
    image: "https://readdy.ai/api/search-image?query=quiet%20window%20nook%20styling%20sheer%20linen%20curtains%20soft%20cushions%20natural%20light%20cream%20beige%20interior%20editorial%20photography%20serene%20calm%20beautiful%20atmosphere&width=640&height=480&seq=rcrel2&orientation=landscape",
  },
  {
    id: 3,
    title: "Warm Minimal Home Decor Ideas",
    category: "Style Guide",
    path: "/style-guide",
    image: "https://readdy.ai/api/search-image?query=warm%20minimal%20home%20decor%20ceramic%20vase%20dried%20flowers%20natural%20linen%20beige%20editorial%20interior%20photography%20flat%20lay%20calm%20serene%20beautiful%20atmosphere%20neutral&width=640&height=480&seq=rcrel3&orientation=landscape",
  },
  {
    id: 4,
    title: "Natural Wood and Linen Interior Looks",
    category: "Style Guide",
    path: "/style-guide",
    image: "https://readdy.ai/api/search-image?query=natural%20wood%20linen%20interior%20looks%20oak%20furniture%20linen%20fabric%20texture%20warm%20neutral%20beige%20home%20editorial%20photography%20calm%20atmosphere%20beautiful%20serene&width=640&height=480&seq=rcrel4&orientation=landscape",
  },
];

export default function RCArticleRelated() {
  return (
    <section className="py-20 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        <div className="mb-12">
          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Continue Reading
          </p>
          <h2
            className="text-[#2C2825] text-3xl md:text-4xl"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            More calm spaces to explore
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {relatedArticles.map((article) => (
            <Link key={article.id} to={article.path} className="group cursor-pointer block">
              <div className="relative overflow-hidden rounded-xl bg-[#EDE6DA] aspect-[4/3] mb-4">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                <div className="absolute top-3 left-3">
                  <span
                    className="bg-[#FAF7F0]/90 text-[#6B5E53] text-[9px] px-2.5 py-1 rounded-full tracking-wider"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {article.category}
                  </span>
                </div>
              </div>
              <h3
                className="text-[#2C2825] text-sm leading-snug group-hover:text-[#6B5E53] transition-colors"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
              >
                {article.title}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
